export var repeat = function (repetitions) {
    return {
        it: function (title, fn) {
            for (var index = 1; index <= repetitions; index++) {
                // tslint:disable-next-line:no-only-tests
                it.only(title + " Run:" + index + "/" + repetitions, fn);
            }
        }
    };
};
//# sourceMappingURL=repeat.js.map